import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';

import themed from 'webapp/decorators/themed';
import FormCheckboxSingleComponent from 'webapp/components/form/checkbox-single';

interface Args {
	name: string;
	selected: boolean | undefined;
	onChange: (value: boolean) => void;
	onBeforeChange?: (changingTo: boolean) => Promise<unknown>;
	isDisabled?: boolean;
	theme?: string;
	size?: string;
}

interface FormCheckboxSwitchComponentInterface<T> {
	Element: HTMLDivElement; // this is needed for ...attributes
	Args: T;
}

@themed()
export default class FormCheckboxSwitchComponent extends Component<
	FormCheckboxSwitchComponentInterface<Args>
> {
	declare themeClass: string; // from @themed
	declare sizeClass: string; // from @themed

	id = 'switch-' + guidFor(this);
	<template>
		<div class="checkbox-switch {{this.themeClass}} {{this.sizeClass}}" ...attributes>
			<FormCheckboxSingleComponent
				class="checkbox-switch__toggler"
				@id={{this.id}}
				@name={{@name}}
				@selected={{@selected}}
				@isDisabled={{@isDisabled}}
				@onBeforeChange={{@onBeforeChange}}
				@onChange={{@onChange}}
			/>

			<label for={{this.id}} class="checkbox-switch__label"></label>

		</div>
	</template>
}
